<template>
  <div>

    <h2>{{ $t('title.' + action + '.organization') }}</h2>

    <el-row :gutter="40">

      <el-col :span="12">

        <data-form
          model="organizations"
          :entity="organization"
          :fields="fields"
          :before-submit="beforeSubmit"
          :after-submit="afterSubmit"  />

      </el-col>

      <el-col :span="12">

        <h4>{{ $t('related-users') }}</h4>

        <data-table
          model="users"
          :columns="['email']"
          :isSelected="isUserSelected"
          @selection-change="userSelectChanged"/>

      </el-col>

    </el-row>

  </div>
</template>

<script>
export default {
  name: 'organization-details',
  data () {
    return {
      relatedUsers: []
    }
  },
  computed: {
    organization () {
      const id = this.$route.params.id

      if (id === 'new') {
        return { new: true, owner_id: null, relatedUserIds: [] }
      }

      return this.$store.getters['organizations/findById'](id, this.$store.dispatch)
    },
    fields () {
      return {
        'name': {
          type: 'text',
          rules: [{ required: true }, { max: 80 }]
        },
        'description': {
          type: 'textarea',
          rules: [{ required: true }, { max: 80 }]
        },
        'owner_id': {
          type: 'select',
          options: this.filterOwners(),
          filter: this.filterOwners,
          rules: [{ required: true }]
        }
      }
    },
    action () {
      return this.organization.new ? 'create' : 'edit'
    }
  },
  methods: {
    beforeSubmit (formModel) {
      formModel.relatedUserIds = this.relatedUsers.map(u => u.id)
    },
    afterSubmit (formModel) {
      this.$router.back()
    },
    filterOwners (query) {
      const owners = this.$store.getters['owners/data'](this.$store.dispatch)

      return owners
        .map(owner => ({ label: owner.name, value: owner.id }))
        .filter(option => option.label.toLowerCase().includes((query || '').toLowerCase()))
    },
    isUserSelected (user) {
      return this.organization.relatedUserIds.includes(user.id)
    },
    userSelectChanged (users) {
      this.relatedUsers = users
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// OrganizationDetails.vue?05b47c3b